import { PaymentObjectiveModel } from '../models/paymentObjective'

export const InitialPaymentObjectives: PaymentObjectiveModel[] = [
  {
    name: 'premium_NB',
    amount: 0,
    paymentObjectiveType: { id: 1, name: 'เบี้ยงวดแรก', description: 'premium_NB' },
    isCheck: false
  },
  {
    name: 'premium_add_NB',
    amount: 0,
    paymentObjectiveType: {
      id: 2,
      name: 'เบี้ยเพิ่มเติมใบคำขอฯ รายใหม่',
      description: 'premium_add_NB'
    },
    isCheck: false
  },
  {
    name: 'premium_change',
    amount: 0,
    paymentObjectiveType: {
      id: 3,
      name: 'เบี้ยเปลี่ยนแปลง/ต่ออายุกรมธรรม์/เงินกู้อัตโนมัติ(APL)',
      description: 'premium_change'
    },
    isCheck: false
  },
  {
    name: 'premium_renew',
    amount: 0,
    paymentObjectiveType: {
      id: 4,
      name: 'เบี้ยงวดถัดไป/ปีต่ออายุ',
      description: 'premium_renew'
    },
    isCheck: false
  },
  {
    name: 'premium_loan',
    amount: 0,
    paymentObjectiveType: {
      id: 5,
      name: 'เงินกู้/ดอกเบี้ย',
      description: 'premium_loan'
    },
    isCheck: false
  },
  {
    name: 'premium_extra',
    amount: 0,
    paymentObjectiveType: {
      id: 6,
      name: 'เบี้ยประกันภัยเพิ่มเติมพิเศษ - งวดปีต่อ',
      description: 'premium_extra'
    },
    isCheck: false
  },
  // {
  //   name: 'premium_group',
  //   amount: 0,
  //   paymentObjectiveType: {
  //     id: 7,
  //     name: 'เบี้ยประกันภัยกลุ่ม',
  //     description: 'premium_group'
  //   },
  //   isCheck: false
  // },
  {
    name: 'premium_oth_fee',
    amount: 0,
    paymentObjectiveType: {
      id: 8,
      name: 'ค่าธรรมเนียมอื่นๆ',
      description: 'premium_oth_fee'
    },
    isCheck: false
  }
]
